import { Button } from '@/components/ui/button';
import { useApp } from '@/context/AppContext';
import { useToast } from '@/hooks/use-toast';

export function BadgeTestButton() {
  const { state, logActivity } = useApp();
  const { toast } = useToast();

  const testBadgeUnlock = async () => {
    console.log('🧪 Testing badge unlock system...');
    console.log('Current state:', {
      isAuthenticated: state.isAuthenticated,
      totalPoints: state.totalPoints,
      badgeCount: state.badges?.length || 0,
      unlockedBadges: state.badges?.filter(b => b.unlockedAt).length || 0
    });

    // Log a test activity to trigger badge checking
    if (logActivity) {
      await logActivity({
        id: 'test-badge-unlock',
        name: 'Test Badge Unlock',
        points: 10,
        icon: undefined as any,
        color: 'blue',
        description: 'Testing badge unlock system'
      });
      
      toast({
        title: "Badge Test",
        description: "Logged a test activity. Check console for badge debug info.",
      });
    }
  };

  return (
    <Button 
      onClick={testBadgeUnlock}
      variant="outline"
      className="mb-4"
    >
      🧪 Test Badge System
    </Button>
  );
}